import config from "../config.json";
import http from "./httpService";


function login(data) {
    return http.post(`${config.apiUrl}/api/Accounts/Login`, data);
}

function RequestVerifyCode(data) {
    return http.post(`${config.apiUrl}/api/Accounts/RequestVerifyCode`, data);
}

function CheckVerifyCode(data) {
    return http.post(`${config.apiUrl}/api/Accounts/CheckVerifyCode`, data);
}

function ChengePassWithVerifyCode(data) {
    return http.post(`${config.apiUrl}/api/Accounts/ChengePassWithVerifyCode`, data);
}

function Register(data) {
    return http.post(`${config.apiUrl}/api/Accounts/Register`, data);
}

function GetUserInfo() {
    return http.post(`${config.apiUrl}/api/Accounts/GetUserInfo`);
}


function ChangeProfile(data){
    
    let form = new FormData();
   // form.append('id', data.id);
    form.append('name', data.name); 
    form.append('mobile', data.mobile); 
    form.append('showData', data.showData); 
    form.append('instagram', data.instagram); 
    form.append('telegram', data.telegram); 
    form.append('baleh', data.baleh); 
    form.append('eita', data.eita); 
    form.append('whatsapp', data.whatsapp);  
    if (data.pic)
        form.append('file', data.pic);  
    http.setJwt(http.getLocalJwt());
    return http.post(`${config.apiUrl}/api/Accounts/ChangeProfile`, form)
}

function getProfile() {
    http.setJwt(http.getLocalJwt());
    return http.post(`${config.apiUrl}/api/Accounts/getProfile`);
}

function QrCodeList() {
    http.setJwt(http.getLocalJwt());
    return http.get(`${config.apiUrl}/api/UserQrCodes/list`);
}

function QrCodeDelete(id) {
    http.setJwt(http.getLocalJwt());
    return http.post(`${config.apiUrl}/api/UserQrCodes/delete?id=${id}`);
}


function QrCodeNew1(data) {
    http.setJwt(http.getLocalJwt());
    return http.post(`${config.apiUrl}/api/UserQrCodes/new1`,data);
}
function QrCodeGet(id) {
    http.setJwt(http.getLocalJwt());
    return http.get(`${config.apiUrl}/api/UserQrCodes/Get?id=${id}`);
}
function QrCodePost(data) {
    http.setJwt(http.getLocalJwt());
    return http.post(`${config.apiUrl}/api/UserQrCodes/Post`,data);
}

function QrCodeRead(code) {
    http.setJwt(http.getLocalJwt());
    return http.get(`${config.apiUrl}/api/UserQrCodes/Read?code=${code}`);
}

function QrCodeFind(code) {
    http.setJwt(http.getLocalJwt());
    return http.post(`${config.apiUrl}/api/UserQrCodes/Find?code=${code}`);
}


function ExhibitionPost(data) { 
    return http.post(`${config.apiUrl}/Exhibition/SaveData`,data);
}
 


export default {
    login,RequestVerifyCode,CheckVerifyCode,ChengePassWithVerifyCode,Register
    ,GetUserInfo
    ,QrCodeList,QrCodeDelete,QrCodeNew1,QrCodeGet,QrCodePost,QrCodeRead,QrCodeFind
    ,ExhibitionPost,getProfile,ChangeProfile
   


};
